module.exports = __webpack_public_path__ + "img/mickey.ac5e942c.svg";